/**
 * Copyright 2019-2021 (c) Christian von Arnim, ISW University of Stuttgart (for umati and VDW e.V.)
 * Copyright 2021 (c) Moritz Walker, ISW University of Stuttgart (for umati and VDW e.V.)
 * Copyright 2021 (c) Karsten Röthig, FVA GmbH (for umati and VDW e.V.)
*/
import { labels } from '@umati/dashboard-common';
import { StacklightLamp } from '@umati/dashboard-types';
import React from 'react';
import StatusTimeline from '../../timeline/StatusTimeline';
import DetailGallery from './DetailGallery';

interface ImageAndTimelineProps {
  machineId: string;
  machineType?: string;
  defaultImagePathClassifier?: string;
  lamps?: StacklightLamp[];
  hideTimeline?: boolean;
  lampColors?: string[];
  imagePath?: string;
  timelineColorMap?: {[key: string]: string};
}

export default function ImageAndTimeline (props: ImageAndTimelineProps) {
  const machineId = props.machineId;
  const lamps = props.lamps;
  return (
    <div className="row mb-4">
      <div className="col-12 col-lg-5">
        <DetailGallery imagePath={props.imagePath} machineId={machineId} lamps={lamps} colors={props.lampColors} defaultImagePathClassifier={props.defaultImagePathClassifier} machineType={props.machineType}/>
      </div>
      <div className="col-12 col-lg-7">
        {!props.hideTimeline &&
          <div className="mb-1 mb-md-2 mb-lg-4">
            <h3 className="h5">{labels.statusOverview}</h3>
            <div className="status-timeline">
              <StatusTimeline namespaceUri={machineId} colorMap={props.timelineColorMap}/>
            </div>
          </div>
        }
      </div>
    </div>
  );
}
